module.exports = __webpack_public_path__ + "img/09.8bc47bd1.png";